import { render, staticRenderFns } from "./userAllocation.vue?vue&type=template&id=e9da982a&scoped=true"
import script from "./userAllocation.vue?vue&type=script&lang=js"
export * from "./userAllocation.vue?vue&type=script&lang=js"
import style0 from "./userAllocation.vue?vue&type=style&index=0&id=e9da982a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9da982a",
  null
  
)

export default component.exports